import { useQuery } from 'react-query';
import { StaticService } from '../services';

export const useGetPrivacyPolicy = () =>
  useQuery('privacyPolicy', () => StaticService.getPrivacyPolicy());
